export default function guest({ to, next, stores }) {
  const loginQuery = { path: '/', query: { redirect: to.fullPath } };

  if (stores.auth.authUser) {
    {next(loginQuery);}
  } else {
    next();
  }
}
